// import React from "react";
// import {
//   Box,
//   Grid,
//   Typography,
//   Paper,
//   IconButton,
//   Switch,
// } from "@mui/material";
// import EditIcon from "@mui/icons-material/Edit";
// import DeleteIcon from "@mui/icons-material/Delete";
// import SaveIcon from "@mui/icons-material/Save";
// import { useForm } from "react-hook-form";

// import WSSelectField from "../../../Components/Select/WSSelect";
// import WSTextField, { TextType, CurrencyType } from "../../../Components/TextBox/WSTextBox";
// import config from "../../../Config/clientConfig.json" 
// import WSPhone from "../../../Components/Phone/WSPhone";

// const User = () => {
//   const { control } = useForm();



//   return (
//     <Box sx={{ p: 2, background: "#f0f0f0", minHeight: "100vh" }}>

//       {}
//       <Box display="flex" justifyContent="space-between" mb={4}>
//         <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
//           User Managment
//         </Typography>

//         <Box>
//           <IconButton sx={{ background: "#000", color: "#fff", mr: 1 }}>
//             <EditIcon fontSize="small" />
//           </IconButton>
//           <IconButton sx={{ background: "#000", color: "#fff" }}>
//             <DeleteIcon fontSize="small" />
//           </IconButton>
//         </Box>
//       </Box>

//       {}
//       <Paper
//         sx={{
//           borderRadius: "16px",
//           p: 5,
//           background: "#fafafa",
//         }}
//       >
//         {}
//        <Box display="flex" justifyContent="space-between" mb={7}>
//           <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
//             User Details
//           </Typography>

//           <IconButton sx={{ background: "#000", color: "#fff" }}>
//             <SaveIcon fontSize="small" />
//           </IconButton>
//         </Box>
//        <Grid container rowSpacing={8} columnSpacing={5}>


//           <Grid item xs={4}>
//             <WSTextField
//               name="name"
//               label="Name"
//               id="name"
//               control={control}

//             />
//           </Grid>

//           <Grid item xs={4}>
//             <WSTextField
//               name="email"
//               label="Email"
//               id="email"
//               control={control}

//             />
//           </Grid>

//           {}
//           <Grid item xs={4} >
//             <WSSelectField
//               name="role"
//               label="Role"
//               id="role"
//               control={control}
//               options={config.RoleConfig.staticOptionData}



//             />
//           </Grid>



//           <Grid item xs={4}>
//             <WSPhone
//               name="phone"
//               label="Phone Number"
//               id="phone"
//               control={control}

//             />
//           </Grid>



//           {}
//           <Grid item xs={4}>
//             <WSTextField
//               name="password"
//               label="Create Password"
//               id="password"
//               control={control}
//               type={TextType.Password}


//             />
//           </Grid>

//            <Grid item xs={4}>
//             <WSTextField
//               name="confirmpass"
//               label="Confirm Password"
//               id="confirmpass"
//               control={control}
//               type={TextType.Password}


//             />
//           </Grid>


//         </Grid>
//       </Paper>
//     </Box>
//   );
// };

// export default User;


import React, { useState, useEffect } from "react";
import {
  Box,
  Grid,
  Typography,
  Paper,
  IconButton,
  CircularProgress,
  Tooltip,
} from "@mui/material";
import EditIcon from "@mui/icons-material/Edit";
import DeleteIcon from "@mui/icons-material/Delete";
import SaveIcon from "@mui/icons-material/Save";
import ArrowBackIcon from "@mui/icons-material/ArrowBack";
import DeleteForeverIcon from "@mui/icons-material/DeleteForever";
import { useForm } from "react-hook-form";
import { useParams, useNavigate } from "react-router-dom";
import WSSelectField from "../../../Components/Select/WSSelect";
import WSTextField, { TextType } from "../../../Components/TextBox/WSTextBox";
import WSPhone from "../../../Components/Phone/WSPhone";
import { customValidation, validations, callAPI, Method } from "../../../commonFunctions/CommonFunctions";
import { useSnackbar } from "../../../Components/Snackbar/SnackBarContext";
import config from "../../../Config/clientConfig.json";

const User = () => {
  const [loading, setLoading] = useState(false);
  const [isEditMode, setIsEditMode] = useState(false);
  const [deleteConfirm, setDeleteConfirm] = useState(false);
  const { showMessage } = useSnackbar();
  const params = useParams();
  const id = params.id;
  const navigate = useNavigate();

  const {
    control,
    handleSubmit,
    reset,
    formState: { isValid },
    watch,
  } = useForm({
    mode: "onChange",
    defaultValues: {
      full_name: "",
      email: "",
      phone: "",
      password: "",
      confirmpass: "",
      role: "",
    },
  });

  const password = watch("password");

  useEffect(() => {

    if (!id || id === "undefined" || id === "null" || id.trim() === "") {
      setIsEditMode(false);
      reset();
      return;
    }

    setIsEditMode(true);
    fetchUserData(id);
  }, [id, showMessage, reset]);

  // ✅ FIXED: Correct API path
  const fetchUserData = async (userId: string) => {
    try {
      setLoading(true);

      const response = await callAPI(`users/${userId}`, Method.GET);

      if (response?.success && response.data) {
        const userData = response.data;

        reset({
          full_name: userData.full_name || "",
          email: userData.email || "",
          phone: userData.phone || "",
          role: userData.role || "",
          password: "",
          confirmpass: "",
        });
      } else {
        console.error("❌ No data in response:", response);
        showMessage(response?.message || `User ${userId} not found`, "error");
        setIsEditMode(false);
      }
    } catch (error: any) {
      console.error("❌ Fetch error:", error.response?.data || error.message);
      showMessage("Failed to load user data", "error");
      setIsEditMode(false);
    } finally {
      setLoading(false);
    }
  };

  // ✅ FIXED: Correct API paths
  const onSubmit = async (data: any) => {
    try {
      setLoading(true);
      const requestBody = {
        full_name: data.full_name?.trim(),
        email: data.email?.trim(),
        phone: data.phone || "",
        role: data.role,
        password: data.password,
      };


      let response;
      if (isEditMode && id) {
        response = await callAPI(`users/${id}`, Method.PUT, requestBody);
      } else {
        response = await callAPI("users/create", Method.POST, requestBody);
      }

      if (response?.success) {
        showMessage(
          isEditMode ? "User updated successfully!" : "User created successfully!",
          "success"
        );
        navigate("/user/list");
      } else {
        showMessage(response?.message || "Operation failed", "error");
      }
    } catch (error: any) {
      console.error("❌ Submit error:", error);
      showMessage(error?.message || "Operation failed", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleDeleteClick = () => {
    if (!id) return;
    setDeleteConfirm(true);
  };

  // ✅ FIXED: Correct API path
  const handleDelete = async () => {
    if (!id) return;

    try {
      setLoading(true);

      const response = await callAPI(`users/${id}`, Method.DELETE);

      if (response?.success) {
        showMessage("User deleted successfully!", "success");
        navigate("/user/list");
      } else {
        showMessage(response?.message || "Delete failed", "error");
      }
    } catch (error: any) {
      console.error("❌ Delete error:", error);
      showMessage(error?.response?.data?.message || "Delete failed", "error");
    } finally {
      setLoading(false);
      setDeleteConfirm(false);
    }
  };

  const handleCancelDelete = () => {
    setDeleteConfirm(false);
  };

  const handleBack = () => {
    navigate("/user/list");
  };

  return (
    <Box sx={{ p: 2, background: "#f0f0f0", minHeight: "100vh" }}>
      { }
      <Box display="flex" justifyContent="space-between" alignItems="center" mb={4}>
        <Box display="flex" alignItems="center" gap={2}>
          <IconButton onClick={handleBack} sx={{ background: "#000", color: "#fff" }}>
            <ArrowBackIcon fontSize="small" />
          </IconButton>
          <Typography sx={{ fontSize: "20px", fontWeight: 600 }}>
            {isEditMode ? "Edit User" : "User Management"}
          </Typography>
        </Box>
        <Box>
          <IconButton sx={{ background: "#000", color: "#fff", mr: 1 }}>
            <EditIcon fontSize="small" />
          </IconButton>
          {isEditMode && id && (
            <IconButton
              onClick={handleDeleteClick}
              disabled={loading}
              sx={{
                background: "#dc3545",
                color: "#fff",
                "&:hover": { background: "#c82333" }
              }}
            >
              {loading ? <CircularProgress size={20} color="inherit" /> : <DeleteIcon fontSize="small" />}
            </IconButton>
          )}
        </Box>
      </Box>

      { }
      {deleteConfirm && (
        <Paper sx={{ p: 4, mb: 3, background: "#fff3cd", border: "1px solid #ffeaa7" }}>
          <Typography color="warning.main" sx={{ fontWeight: 500, mb: 2 }}>
            Delete User ID: {id?.slice(0, 8)}...?
          </Typography>
          <Typography sx={{ mb: 3, color: "text.secondary" }}>
            This action cannot be undone.
          </Typography>
          <Box display="flex" gap={2}>
            <IconButton
              onClick={handleDelete}
              disabled={loading}
              sx={{ background: "#dc3545", color: "white", "&:hover": { background: "#c82333" } }}
            >
              {loading ? <CircularProgress size={20} color="inherit" /> : <DeleteForeverIcon />}
            </IconButton>
            <IconButton
              onClick={handleCancelDelete}
              sx={{ background: "#6c757d", color: "white", "&:hover": { background: "#5a6268" } }}
            >
              Cancel
            </IconButton>
          </Box>
        </Paper>
      )}

      { }
      <Paper
        sx={{
          borderRadius: "16px",
          p: 5,
          background: "#fafafa",
          position: "relative"
        }}
      >
        {loading && (
          <Box sx={{
            position: "absolute",
            top: 0, left: 0, right: 0, bottom: 0,
            background: "rgba(255,255,255,0.9)",
            display: "flex", alignItems: "center", justifyContent: "center",
            zIndex: 10, borderRadius: "16px"
          }}>
            <CircularProgress />
          </Box>
        )}

        { }
        <Box display="flex" justifyContent="space-between" mb={7}>
          <Typography sx={{ fontSize: "18px", fontWeight: 500 }}>
            {isEditMode ? "User Details" : "User Details"}
          </Typography>

          <Tooltip title={isEditMode ? "Update User" : "Create User"} arrow>
            <IconButton
              sx={{ background: "#000", color: "#fff" }}
              onClick={handleSubmit(onSubmit)}
              disabled={!isValid || loading}
            >
              <SaveIcon fontSize="small" />
            </IconButton>
          </Tooltip>
        </Box>

        <form noValidate>
          <Grid container rowSpacing={8} columnSpacing={5}>
            <Grid item xs={4}>
              <WSTextField
                name="full_name"
                label="Name"
                id="full_name"
                control={control}
                rules={{ required: "Name is required" }}
              />
            </Grid>

            <Grid item xs={4}>
              <WSTextField
                name="email"
                label="Email"
                id="email"
                control={control}
                rules={customValidation(true, validations.email)}
              />
            </Grid>

            <Grid item xs={4}>
              <WSPhone
                name="phone"
                label="Phone Number"
                id="phone"
                control={control}
                rules={{ required: "Phone number is required" }}
              />
            </Grid>

            <Grid item xs={4}>
              <WSSelectField
                name="role"
                label="Role"
                id="role"
                control={control}
                options={config.RoleConfig.staticOptionData}
                rules={{ required: "Role is required" }}
              />
            </Grid>

            <Grid item xs={4}>
              <WSTextField
                name="password"
                label={isEditMode ? "New Password (leave blank to keep current)" : "Create Password"}
                id="password"
                control={control}
                type={TextType.Password}
                rules={
                  isEditMode
                    ? {}
                    : { required: "Password is required", minLength: { value: 6, message: "Minimum 6 characters" } }
                }
              />
            </Grid>

            <Grid item xs={4}>
              <WSTextField
                name="confirmpass"
                label="Confirm Password"
                id="confirmpass"
                control={control}
                type={TextType.Password}
                rules={
                  isEditMode
                    ? {}
                    : {
                      required: "Confirm password is required",
                      validate: (value) => value === password || "Passwords do not match",
                    }
                }
              />
            </Grid>
          </Grid>
        </form>
      </Paper>
    </Box>
  );
};

export default User;
